import i18next from 'i18next';

i18next.addResources('es_CL', 'OrderModalFooter', {
  subtotal: 'Precio subtotal',
  delivery: 'Delivery fee',
  totalPrice: 'Precio total'
});
